let videoPlay = document.getElementsByClassName('video-component__video');

for (let i = 0; i < videoPlay.length; i++) {
    videoPlay[i].addEventListener("click", function(e) {

        // Find the image in the container and hide it.
        let img = this.querySelectorAll("img");
        img[0].classList.add("video-component__img--hidden");

        // Find the iframe in the container, make visible, add src and add in tab order.
        let iframe = this.querySelectorAll("iframe");
        let videoSrc = iframe[0].getAttribute("data-video");
        iframe[0].setAttribute("src",videoSrc);
        iframe[0].classList.add("video-component__frame--visible");
        iframe[0].removeAttribute("tabindex");

        // Custom tag manager event for video tracking
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'event': 'play_video_button'});
    });
}